import apiFetch from '../apiFetch'

export default function (id, token) {
  return apiFetch({endPoint: `ComboCausaEliminacion/getComboCausaEliminacion?id=${id}`, method: 'GET', body: null, token: token})
}
